import type { FilterDefinition, FilterHandler } from '../engine/types';
import {
  FilterId,
  FilterType,
  type MultiFilter,
  type RangeFilter,
  type SegmentedFilter,
} from '../types/filters';

export const multiHeadcountDefinition: FilterDefinition<
  MultiFilter<SegmentedFilter<RangeFilter>>
> = {
  id: FilterId.MULTI_HEADCOUNT,
  name: 'Headcount',
  type: FilterType.MULTI,
  wrappedFilterId: FilterId.HEADCOUNT,
  instances: [],
  isVisible: true,
};

export const multiHeadcountHandler: FilterHandler<
  MultiFilter<SegmentedFilter<RangeFilter>>
> = {
  isActive(currentFilterState) {
    return currentFilterState.instances.length > 0;
  },
  isDefault(currentFilterState) {
    return currentFilterState.instances.length === 0;
  },
  getEffectiveFilter(currentFilterState) {
    return currentFilterState;
  },
};
